"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleLoginForm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_google_login_1 = require("react-google-login");
var GoogleLoginApiClient_1 = require("./GoogleLoginApiClient");
var acorn_react_core_1 = require("@gcdtech/acorn-react-core");
var GoogleLoginForm = function (props) {
    var authenticationContext = react_1.useContext(acorn_react_core_1.AuthenticationContext);
    var onSuccess = function (idToken) { return __awaiter(void 0, void 0, void 0, function () {
        var acornToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GoogleLoginApiClient_1.GoogleLoginApiClient.get().login(idToken)];
                case 1:
                    acornToken = _a.sent();
                    // Do our essentials
                    try {
                        authenticationContext.login(acornToken);
                    }
                    catch (e) {
                        console.log(e);
                    }
                    // Call our parent for any additional processing
                    if (props.onSuccess) {
                        props.onSuccess(idToken);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    react_1.useEffect(function () {
        if (window.location.hash) {
            var token = window.location.hash.match(/\id_token\=([\S\s\&]*?)\&/)[1];
            console.log(token);
            onSuccess(token);
        }
    }, [window.location.hash]);
    var onFormSuccess = function (response) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // @ts-ignore - response.tokenId does exist but the type doesn't provide it
            onSuccess(response.tokenId);
            return [2 /*return*/];
        });
    }); };
    var onFormFailure = function (response) {
        // Call our parent for any additional processing
        if (props.onFailure) {
            props.onFailure();
        }
    };
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: !window.location.hash && (jsx_runtime_1.jsx(react_google_login_1.GoogleLogin
        // Defaults for optional values
        , __assign({ 
            // Defaults for optional values
            buttonText: "Sign-in With Google" }, props, { onSuccess: onFormSuccess, onFailure: onFormFailure, cookiePolicy: 'single_host_origin' }), void 0)) }, void 0));
};
exports.GoogleLoginForm = GoogleLoginForm;
//# sourceMappingURL=GoogleLoginForm.js.map